import { ShoppingCartThemeSizeConfig } from './types';

const medium: ShoppingCartThemeSizeConfig = {
  shoppingCart: {},
};

export default medium;
